"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Sidebar_1 = __importDefault(require("./Sidebar"));
exports.default = Sidebar_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/Sidebar/index.js
// module id = 1840
// module chunks = 0